export const common = {
  title: "SDO React版本框架展示",
  foot: "叡揚資訊股份有限公司",
  login: {
    announcement: "公告事項",
    userId: "使用者帳號",
    userPd: "使用者密碼",
    login: "登入",
    required01: "請輸入帳號",
    required02: "請輸入密碼",
  },
  home: {
    techName: "專案使用技術",
    refer: "參考網址",
  },
  button: {
    query: "查詢",
    create: "新增",
    update: "修改",
    delete: "刪除",
    save: "存檔",
    reset: "重設",
    cancel: "取消",
    ok: "確定",
    view: "檢視",
  },
  message: {
    required01: "{} 必填",
    required02: "起始日期 必填",
    required03: "到期日期 必填",
    required04: "到期日期不可早於起始日期",
    required05: "{} 不是有效的電子郵件地址。",
    delete01: "進行刪除作業，確定嗎?",
    delete02: "確定要刪除此使用者嗎?",
    delete03: "確認要刪除這些組織嗎?",
    success01: "成功",
    fail01: "失敗",
    uploadLimit: "上傳檔案限制",
  },
  date: {
    date01: "tYY/MM/DD",
  },
};
